<template>
	<div class="container">
		<h2 class="form-signin-heading" aria-hidden="false">Create an account</h2>
		<b-form @submit.prevent="submitForm">
			<b-form-group
				id="emailGroup"
				label="Enter your email"
				label-for="email"
				label-class="hidden"
				:state="emailState"
				:invalid-feedback="emailInvalidFeedback"
			>
				<b-form-row>
					<b-form-input
						id="email"
						type="email"
						:state="emailState"
						v-model.trim="email"
						class="form-control"
						name="email"
						placeholder="email@example.com"
						required
						v-focus
					></b-form-input>
				</b-form-row>
			</b-form-group>
			<b-form-group
				id="passwordGroup"
				label="Enter your password"
				label-for="password"
				label-class="hidden"
				:state="passwordState"
				:invalid-feedback="passwordInvalidFeedback"
			>
				<b-form-row>
					<b-form-input
						id="password"
						type="password"
						:state="passwordState"
						v-model="password"
						class="form-control"
						name="password"
						required
						placeholder="Password"
					></b-form-input>
					<b-form-text id="inputLiveHelp">
						Minimum of 8 characters that has at least 1 of each of the
						following: lowercase letter, uppercase letter, number and
						!@#$%^&*()_-+{}[]|&lt;&gt;?~
					</b-form-text>
				</b-form-row>
			</b-form-group>
			<b-form-group
				id="passwordConfirmGroup"
				label="Confirm your password"
				label-for="passwordConfirm"
				label-class="hidden"
				:state="passwordConfirmState"
				:invalid-feedback="passwordConfirmInvalidFeedback"
			>
				<b-form-row>
					<b-form-input
						id="passwordConfirm"
						type="password"
						:state="passwordConfirmState"
						v-model="passwordConfirm"
						class="form-control"
						name="passwordConfirm"
						required
						placeholder="Confirm Password"
					></b-form-input>
				</b-form-row>
			</b-form-group>
			<b-form-row>
				<b-col>
					<b-button
						:disabled="disableForm()"
						variant="primary"
						class="formSubmit"
						type="submit"
					>
						Create Account
					</b-button>
				</b-col>
				<b-col>
					<b-button
						variant="secondary"
						size="sm"
						class="formSubmit float-right"
						@click="cancel_click()"
					>
						Cancel
					</b-button>
				</b-col>
			</b-form-row>
		</b-form>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "CreateAccount",
	data: function() {
		return {
			email: null,
			password: null,
			passwordConfirm: null
		};
	},
	computed: {
		...mapGetters(["userType"]),
		emailState() {
			if (this.email === null) {
				return null;
			}
			return this.isValidEmail();
		},
		emailInvalidFeedback() {
			if (this.email === null) {
				return "";
			}
			if (this.validEmail(this.email)) {
				return "";
			}
			if (this.email === "") {
				return "Email is required";
			}
			return "Invalid email";
		},
		passwordState() {
			return this.passwordInvalidFeedback === "";
		},
		passwordConfirmState() {
			return this.passwordConfirmInvalidFeedback === "";
		},
		passwordInvalidFeedback() {
			if (!this.password || this.password.length < 8) {
				return "Password needs to be at least 8 characters";
			}

			let missing = [];

			if (!/\d/.test(this.password)) {
				missing.push("number");
			}
			if (!/[a-z]+/.test(this.password)) {
				missing.push("lowercase letter");
			}
			if (!/[A-Z]+/.test(this.password)) {
				missing.push("uppercase letter");
			}
			if (!/[!@#$%^&*()_\-+{}[\]|<>?~]+/.test(this.password)) {
				missing.push("special character");
			}

			if (missing.length > 0) {
				return "Missing the following: " + missing.join(", ");
			}

			let matches = this.password.match(
				/[^a-zA-Z0-9!@#$%^&*()_\-+{}[\]|<>?~]+/
			);
			if (matches !== null) {
				return "Invalid characters";
			}

			return "";
		},
		passwordConfirmInvalidFeedback() {
			if (this.password !== this.passwordConfirm) {
				return "Passwords do not match";
			}
			return "";
		}
	},
	methods: {
		isValidEmail() {
			return this.email !== "" && this.validEmail(this.email);
		},
		disableForm() {
			return !(
				this.isValidEmail() &&
				this.passwordState &&
				this.passwordConfirmState
			);
		},
		submitForm() {
			this.$store.dispatch("create_account", {
				email: this.email,
				password: this.password,
				passwordConfirm: this.passwordConfirm
			});
		},
		cancel_click() {
			this.$router.push("intro");
		}
	},
	watch: {
		userType(value) {
			if (value === "authed") {
				this.$router.push("/new-app");
			}
		}
	}
};
</script>

<style scoped></style>
